var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 6.73369C30.3527 3.64396 26.2431 1.94611 21.8755 1.94611C17.5019 1.94611 13.3982 3.64396 10.3085 6.73369C7.21875 9.82342 5.51489 13.9331 5.51489 18.3007C5.51489 27.1379 13.8722 34.4933 18.3658 38.441C18.9897 38.9929 19.5237 39.4669 19.9556 39.8628C20.4956 40.3668 21.1855 40.6188 21.8755 40.6188C22.5654 40.6188 23.2554 40.3668 23.7893 39.8628C24.2213 39.4669 24.7612 38.9929 25.3852 38.441C29.8728 34.4933 38.2301 27.1379 38.2301 18.3007C38.2301 13.9331 36.5322 9.82342 33.4425 6.73369V6.73369Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5149 23.8084H14.6524V24.582H11.5149V23.8084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2421 23.8084H19.3796V24.582H16.2421V23.8084Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6545 23.8084H28.7919V24.582H25.6545V23.8084Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9702 23.8084H24.0647V24.582H20.9702V23.8084Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3828 23.8084H33.5203V24.582H30.3828V23.8084Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5149 24.8311H33.52V26.8253H11.5149V24.8311Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0962 11.9461H23.1794C23.1321 11.9461 23.0934 11.9848 23.0934 12.0321V13.4074C23.0934 13.4547 23.0547 13.4933 23.0074 13.4933H22.0275C21.9802 13.4933 21.9415 13.4547 21.9415 13.4074V12.0321C21.9415 11.9848 21.9029 11.9461 21.8556 11.9461H19.9387C19.8442 11.9461 19.7668 12.0235 19.7668 12.118V17.2755C19.7668 17.37 19.8442 17.4474 19.9387 17.4474H25.0962C25.1908 17.4474 25.2681 17.37 25.2681 17.2755V12.118C25.2681 12.0235 25.1908 11.9461 25.0962 11.9461Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1312 17.8773H20.2143C20.1671 17.8773 20.1284 17.9159 20.1284 17.9632V19.3385C20.1284 19.3858 20.0897 19.4245 20.0424 19.4245H19.0625C19.0152 19.4245 18.9765 19.3858 18.9765 19.3385V17.9632C18.9765 17.9159 18.9378 17.8773 18.8906 17.8773H16.9737C16.8792 17.8773 16.8018 17.9546 16.8018 18.0492V23.2066C16.8018 23.3012 16.8792 23.3785 16.9737 23.3785H22.1312C22.2257 23.3785 22.3031 23.3012 22.3031 23.2066V18.0492C22.3031 17.9546 22.2257 17.8773 22.1312 17.8773Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0618 17.8773H26.1449C26.0977 17.8773 26.059 17.9159 26.059 17.9632V19.3385C26.059 19.3858 26.0203 19.4245 25.973 19.4245H24.9931C24.9458 19.4245 24.9071 19.3858 24.9071 19.3385V17.9632C24.9071 17.9159 24.8684 17.8773 24.8212 17.8773H22.9043C22.8098 17.8773 22.7324 17.9546 22.7324 18.0492V23.2066C22.7324 23.3012 22.8098 23.3785 22.9043 23.3785H28.0618C28.1563 23.3785 28.2337 23.3012 28.2337 23.2066V18.0492C28.2337 17.9546 28.1563 17.8773 28.0618 17.8773Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3668",
    x: 0.0148926,
    y: 0.446106,
    width: 43.7152,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3668",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/cluster.9a49546e748ab274a55e09f5dfa71529.svg";
export { ForwardRef as ReactComponent };